import { CodeChangesRecreatorResult } from '@portal-core/code-editor/types/code-changes-recreator.type';
import { TaskWorkerBase } from '@portal-core/util/task-worker.base';

export class FlareCodeChangesRecreatorTaskWorker extends TaskWorkerBase<CodeChangesRecreatorResult> {
  constructor() {
    super('FlareCodeChangesRecreatorTaskWorker', () => {
      /*
       * Bundlers, including Webpack, Vite, and Parcel, recommend passing URLs that are resolved relative to import.meta.url to the Worker() constructor.
       * This way, the path is relative to the current script instead of the current HTML page, which allows the bundler to safely do optimizations like renaming.
       * Because otherwise the worker.js URL may point to a file not controlled by the bundler, so it cannot make any assumptions.
       */
      return new Worker(new URL('@portal-core/code-editor/workers/flare-code-changes-recreator.worker', import.meta.url));
    });
  }
}
